import React, { useEffect, useState } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { TextInput } from '../../../Helpers/Inputs';
import { setBasicInfo } from '../../../../sessionStorage';
import { useForm, FormProvider } from 'react-hook-form';
import { object, string } from 'yup';
import { Button, SvgIcon, CircularProgress } from "@mui/material";
import Appointment from '../../../../icons/apppointment.svg?react';
import { InputMaskPhone } from "../../../Helpers/Formatters";
import TermScheduler from './TermScheduler';
import { yupResolver } from "@hookform/resolvers/yup";
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined';
import { postApp } from '../../Common/Helpers/PostApp';
import { saveSessionEvent } from "../../../../session";
import PropTypes from 'prop-types';
import { ComplimentaryReview, DisclosureText } from '../../Common/Appointment/CustomAppointmentData';
import { ConfigurableQuestions, configurableQuestionsSchemaShape } from '../../Common/Appointment/ConfigurableQuestions';
import './ScheduleForm.scss';

export default function ScheduleForm(props) {

  const isSelectOrTalk = props.quoter.isSelectOrTalk;
  const [postingApp, setPosting] = useState(false);

  const formMethods = useForm({
    resolver: yupResolver(ScheduleForm.ValidationSchema(props.activeQuestionList)),
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: props.formState
  });

  const { handleSubmit, formState: { errors }, setValue } = formMethods;

  const handleValueChange = (field, value) => {
    props.onFieldChange(field, value);
  };

   useEffect(() => {
    let email = props.formState.email, firstName = props.formState.firstName, lastName = props.formState.lastName, phone = props.formState.phone;
    if (props.basicInfo) {
      if (props.basicInfo.firstName) {
        firstName = props.basicInfo.firstName;
      }
      if (props.basicInfo.lastName) {
        lastName = props.basicInfo.lastName;
      }
      if (props.basicInfo.email) {
        email = props.basicInfo.email;
      }
      if (props.basicInfo.phone) {
        phone = props.basicInfo.phone;
      }
    }
    setValue('firstName', firstName);
    setValue('lastName', lastName);
    setValue('email', email);
    setValue('phone', phone);
    props.setMultiField(firstName, lastName, email, phone);
  }, []);

  useEffect(() => {
    // Save data into basic info when updated
    if (props.basicInfo.firstName !== props.formState.firstName) {
      props.basicInfo.firstName = props.formState.firstName;
    }
    if (props.basicInfo.lastName !== props.formState.lastName) {
      props.basicInfo.lastName = props.formState.lastName;
    }
    if (props.basicInfo.email !== props.formState.email) {
      props.basicInfo.email = props.formState.email;
    }
    if (props.basicInfo.phone !== props.formState.phone) {
      props.basicInfo.phone = props.formState.phone;
    }
    setBasicInfo(props.basicInfo);

  }, [props.formState.firstName, props.formState.lastName, props.formState.email, props.formState.phone]);

  const submitPostApp = () => {
    setPosting(true);

    postApp(props.basicInfo, props.quoter, props.sessionStorageHealthData, props.formState, props.quoter.termLength, props.journeyType).then((data) => {
      if (data.success) {
        saveSessionEvent(true);
        props.onNext();
      } else {
        setPosting(false);
      }
    }).finally(() => {
      setPosting(false);
    });
  };

  return (
    <React.Fragment>
      <Row className="justify-content-center text-center mt-2 hide-class">
        <SvgIcon component={Appointment} className="icons" color="primary" fontSize="large" />
      </Row>
      <Row className="justify-content-center pt-2  appointment-heading pb-1">
        <h4>Complete Your Request</h4>
      </Row>
      <Row className='mx-auto appointment-text'>
        {isSelectOrTalk === "contactSpecialist" ?
          <div className="px-0">A licensed insurance professional will help select the best coverage option for you. The quoting process
            is simple and the application typically takes 15 minutes to submit.</div>
          :
          <div className="px-0">We make it quick and easy to start the approval process for your new life insurance policy.
            There’s no paper-work or face-to-face meetings. Simply provide your contact information and one of our dedicated licensed insurance specialists will review your coverage details and complete your application over the phone with you. The call is confidential, hassle-free and takes less than 15 minutes.
            As part of our commitment to your privacy and 100% satisfaction, there’s no payment due until the policy is approved and you have agreed to activate the coverage.
          </div>
        }
        <div className="px-0">{ComplimentaryReview.subText}</div>
      </Row>
      <FormProvider {...formMethods}>
        <Form onSubmit={handleSubmit(submitPostApp)} className='mt-3'>
          <Row>
            <Col md={6} className='w-100'>
              <div className='mb-3'>
                <TextInput
                  name="firstName"
                  id="firstName"
                  label="First Name"
                  value={props.formState.firstName}
                  onChange={(e) => handleValueChange('firstName', e.target.value)}
                />
              </div>
            </Col>
            <Col md={6} className='w-100'>
              <div className='mb-3'>
                <TextInput
                  name="lastName"
                  id="lastName"
                  label="Last Name"
                  value={props.formState.lastName}
                  onChange={(e) => handleValueChange('lastName', e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <div className='mb-3'>
            <TextInput
              name="email"
              id="email"
              label="Email"
              value={props.formState.email}
              onChange={(e) => handleValueChange('email', e.target.value)}
            />
          </div>
          <div>
            <div className="mb-1">
              <TextInput
                name="phone"
                id="phone"
                value={props.formState.phone}
                onChange={(e) => handleValueChange('phone', e.target.value)}
                label="Phone Number"
                InputProps={{
                  inputComponent: InputMaskPhone,
                }}
              />
            </div>
            <ConfigurableQuestions
              formState={props.formState.configurableQuestions}
              onChange={(value) => handleValueChange('configurableQuestions', value)}
              questionData={props.activeQuestionList}
            />
            <div className={`privacySell d-flex justify-content-center mt-3`}>
              Your information is private and secure, and is never sold to a third party.
            </div>
          </div>
          <TermScheduler errors={errors} formState={props.formState} setValue={setValue}
            onFieldChange={(field, value) => props.onFieldChange(field, value)} />
          {postingApp ? (
            <Row className="mt-4">
              <Col>
                <div className="submit-loading-container text-center">
                  <CircularProgress />
                </div>
              </Col>
            </Row>
          ) : (
            <Row className="mt-4">
              <Col className="text-start pb-3 btn-back">
                <Button variant="outlined" className='w-100' size="medium" color="primary" onClick={props.onBack}>
                  BACK
                </Button>
              </Col>
              <Col className="text-end pb-3">
                <Button variant="contained" className='w-100' size="medium" color="primary" type="submit">
                  SUBMIT
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </FormProvider>
      <div className="disclosureText" dangerouslySetInnerHTML={{ __html: DisclosureText }} />
    </React.Fragment>
  );
}

ScheduleForm.propTypes = {
  quoter: PropTypes.object,
  formState: PropTypes.object,
  basicInfo: PropTypes.object,
  onFieldChange: PropTypes.func,
  setMultiField: PropTypes.func,
  sessionStorageHealthData: PropTypes.object,
  onBack: PropTypes.func,
};

ScheduleForm.ValidationSchema = (activeQuestionList) => object().shape({
  firstName: string().required('First Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid First Name'),
  lastName: string().required('Last Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid Last Name'),
  email: string()
    .email('Email Address must be valid.')
    .required('Email Address is required.')
    .nullable(),
  phone: string()
    .required('Phone number is required.')
    .matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
  specificAppt: string()
    .required('Select an appointment option.'),
  timeZone: string().transform(emptyStringToUndefined).when('specificAppt', {
    is: 'schedule',
    then: (schema) => schema.required("Timezone is required."),
    otherwise: (schema) => schema.notRequired(),
  }),
  specificApptDate: string().transform(emptyStringToUndefined).when('specificAppt', {
    is: 'schedule',
    then: (schema) => schema.required("Appointment date is required."),
    otherwise: (schema) => schema.notRequired(),
  }),
  specificApptTime: string()
    .when(['specificAppt', 'specificApptDate', 'timeZone'],
      ([specificAppt, specificApptDate, timeZone], schema) => {
        if (specificAppt === 'schedule' && specificApptDate && timeZone) {
          return schema.required('Time of call is required.');
        }
        return schema.notRequired();
      }
    ),
  configurableQuestions: object().shape(configurableQuestionsSchemaShape(activeQuestionList))
});
